<mat-card>
  <mat-card-title>
    <div class="row">
      <h1 class="fw-semibold col-12 text-center">
        Forgot Password
        <img src="../../../../assets/img/tonic-dots.png"
             alt="Tonic logo" 
             width="50">
      </h1>
    </div>
  </mat-card-title>

  <form [formGroup]="resetForm">

      <mat-form-field appearance="outline">
          <mat-label>Password</mat-label>
          <input matInput type="password" formControlName="password">
          <mat-error *ngIf="getFormControl(resetForm,'password').hasError('required')">Password required</mat-error>
          <mat-error *ngIf="getFormControl(resetForm,'password').hasError('pattern')">Password must include numbers</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline">
          <mat-label>Confirm Password</mat-label>
          <input matInput type="password" formControlName="confirmedPassword">
          <mat-error *ngIf="getFormControl(resetForm,'confirmedPassword').hasError('required')">Password required</mat-error>
          <mat-error *ngIf="getFormControl(resetForm,'confirmedPassword').hasError('noMatch')">Passwords don't match</mat-error>
      </mat-form-field>

      <button mat-flat-button
              color="primary"
              (click)="onReset()"
              [disabled]="resetForm.invalid">Reset</button>

  </form>

  <mat-divider [inset]="true"></mat-divider>

  <mat-card-footer>© {{currentYr}} - Tonic. All rights reserved</mat-card-footer>

</mat-card>
